import React, { useState } from "react";
import CustomModal from "./CustomModal";
import CustomText from "../CustomText";
import Colors from "../../config/Colors";
import Fireworks from "../../assets/ConradulationIcon.svg";
import Confetti from "react-confetti";
import { AwesomeButton } from "react-awesome-button";
import "react-awesome-button/dist/styles.css";
import { isMobile } from "../../types/type";

type CongradulationsModalProps = {
  modalVisible: boolean;
  setModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  onSeePicks?: () => void;
  onClose?:()=>void;
  parent?:boolean
};

const CongradulationsModal: React.FC<CongradulationsModalProps> = ({
  modalVisible,
  setModalVisible,
  onSeePicks,
  onClose,
  parent
}) => {
  const handeOnSeePicks = () => {
    if (onSeePicks) {
      onSeePicks();
    }
    setModalVisible(false);
  };

  const handleClose = () => {
    if(onClose){
      onClose()
    }
  }

  return (
    <CustomModal
      modalVisible={modalVisible}
      height="230px"
      setModalVisible={setModalVisible}
      onClose={handleClose}
      parent={parent}
    >
      <Confetti width={isMobile ? window.innerWidth * 0.9 : 500} height={300} />

      <div className="modalContainer itemsCenter modalContentSpaceBetween">
        <img src={Fireworks} alt="" className="modalCongradulationsIcon" />
        <CustomText color={Colors.primary} size="large" weight="700">
          Congratulations
        </CustomText>
        <CustomText
          color="#8EA0BD"
          size="small"
          weight="500"
          textAlign="center"
        >
          You picks have been submitted successfully!
        </CustomText>
        {/* <button
          onClick={handeOnSeePicks}
          className="buttonRegistrationSubmitButton button"
        >
          <CustomText color={Colors.white} size="smallMedium" weight="700">
            MY PICKS
          </CustomText>
        </button> */}
      </div>
    </CustomModal>
  );
};

export default CongradulationsModal;
